import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BillingManagementService } from 'src/service/billing-management.service';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { GeneralConfigType, InteractionType, KeyValueSet, LocalService, PageKey, PrepaidDetailReason, Wrappers10 } from 'src/service/local.service';

@Component({
  selector: 'app-refund',
  templateUrl: './refund.component.html',
  styleUrls: ['./refund.component.scss']
})
export class RefundComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["prepaid"]; prepaidReasons: KeyValueSet[]; interactionTypes: KeyValueSet[] = [];
  wrapper: Wrappers10; maxBodyHeight = 0; prepaidReason: string = PrepaidDetailReason.Refund.toString();
  ctryCode: string = ''; userId: string = ''; interactionType: InteractionType; businessId: string = ''; reqCtryCode: string = ''; reqInteractionType: string = '';
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, public billingManagementService: BillingManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.PrepaidDetailReason).subscribe(result => {
      this.prepaidReasons = result;
    });

    this.interactionTypes.push({ key: InteractionType.Business.toString(), value: InteractionType[InteractionType.Business] } as KeyValueSet);
    this.interactionTypes.push({ key: InteractionType.ServiceProvider.toString(), value: InteractionType[InteractionType.ServiceProvider] } as KeyValueSet);
    this.interactionTypes.push({ key: InteractionType.User.toString(), value: InteractionType[InteractionType.User] } as KeyValueSet);

    this.route.params.subscribe(routeParams => {
      this.interactionType = parseInt(routeParams.interactionType);
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;
      this.reqCtryCode = routeParams.reqCtryCode;
      this.reqInteractionType = parseInt(routeParams.reqInteractionType).toString();
      this.businessId = routeParams.businessId;
      if (this.interactionType == InteractionType.Bill_PnixSoft) {
        if (this.reqCtryCode == '0')
          this.reqCtryCode = this.ctryCode;
        if (parseInt(this.reqInteractionType) == InteractionType.None)
          this.reqInteractionType = InteractionType.Business.toString();
        this.configurationManagementService.ensurePageActions(PageKey.RefundAdmin);
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
        this.onLoad();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.billingManagementService.getPaidByCompanyDetails(this.businessId, parseInt(this.reqInteractionType), this.wrapper ? this.wrapper.paging : null, this.prepaidReason ? parseInt(this.prepaidReason) : 0, this.reqCtryCode).subscribe(result => {
      this.wrapper = result;
    });
  }

}
